import { render } from "./BastonSarumanView.vue?vue&type=template&id=51057159&scoped=true"
import script from "./BastonSarumanView.vue?vue&type=script&lang=js"
export * from "./BastonSarumanView.vue?vue&type=script&lang=js"

import "./BastonSarumanView.vue?vue&type=style&index=0&id=51057159&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51057159"]])

export default __exports__